import axios from "axios";

const devApiStore = {
  state: {
    method: null,
    url: null,
  },
  mutations: {
    testApi(state, { method, url }) {
      state.method = method;
      state.url = url;
    },
    resultApi(state) {
      state.method = null;
    },
  },
  actions: {
    saveApis({ commit }, { method, url }) {
      console.log("test : ", method, url);
      commit("testApi", { method, url });
    },
    async testApis({ commit }, { method, url }) {
      var param = {
        siteCode: "SITE20210331170738604",
        domain: "apitest.frients.net",
        userEmail: "v@v.com",
        userPw: "1234",
      };

      console.log("rere : ", method, "/wowomomo/" + url);
      axios.post(url, param).then((res) => console.log("결과값:", res));

      commit("resultApi");
    },
  },
};

export default devApiStore;
